module.exports = __webpack_public_path__ + "img/logo.ee7e4850.svg";